import styled from 'styled-components';
import UpcomingActiveSvg from '../../assets/mytrips/upcoming-active.svg';

const UpcomingActiveIcon = styled(UpcomingActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default UpcomingActiveIcon;
